import * as yup from 'yup';

import { MediaType } from 'apps/shared/scripts/__generated__/graphql.generated';

import { MediaFormInput } from '../../types';

import { FORM_FIELDS } from './constants';

export const schema = yup.object().shape({
  [FORM_FIELDS.NAME.name]: yup.string().required('Name is required'),
  [FORM_FIELDS.MEDIA.name]: yup
    .object()
    .shape({
      src: yup.string().required(),
      type: yup.mixed<MediaType>().oneOf(Object.values(MediaType)).required(),
    })
    .nullable()
    .default(undefined),
  [FORM_FIELDS.MESSAGE.name]: yup.string().when(FORM_FIELDS.MEDIA.name, {
    is: (value: MediaFormInput) => !value,
    then: (schema) => schema.required('Message or media is required'),
  }),
});
